import React, { useContext, useEffect } from 'react'
import Hotjar from '@hotjar/browser'
import { useLocation } from 'react-router-dom'
import { DataContext } from './context/DataContext'

export const HotjarProvider = () => {
   const location = useLocation()
   const dataContext = useContext(DataContext)
   const { userAccount } = dataContext.state
   const siteId = Number(process.env.REACT_APP_HOTJAR_SITE_ID)
   useEffect(() => {
      if (siteId) {
         const hotjarVersion = 6

         if (siteId && userAccount) {
            Hotjar.init(siteId, hotjarVersion)
         }
      }
   }, [userAccount, siteId])

   useEffect(() => {
      if (siteId) Hotjar.stateChange(location.pathname)
   }, [location, siteId])

   return <></>
}
